import {httpGet, httpPost} from './base'

export const loadOrgClasses = () => { return httpGet('cond/orgClasses').then(res => res) }
export const loadCustomers = () => { return httpGet('cond/customers').then(res => res) }
export const loadClasses = (schoolIds) => { return httpPost('cond/classes', schoolIds).then(res => res) }
export const loadModeList = () => { return httpGet('cond/modeList').then(res => res) }



// WEBPACK FOOTER //
// ./src/api/condition.js